module.exports = __webpack_public_path__ + "img/四星特级大师@3x.4be05912.png";